<template>
  <div class="intercom-banner">
    <img :src="intercomBanner" alt="" />
    <div class="absolute">
      <div class="title">楼宇对讲</div>
      <div class="text">
        楼宇对讲又称可视对讲，用图像和声音来识别来访客人，控制门锁及遇到紧急情况向管理中心发送求助、求援信号，管理中心亦可向住户发布信息的设备集成。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import intercomBanner from "../../../../assets/programme/intercomBanner.png";

export default {
  setup() {
    return reactive({
      intercomBanner: intercomBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.intercom-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .intercom-banner {
    min-width: 1180px;
  }
}
.intercom-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 50px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
